import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMadlibOptionsState } from './../reducers/madlib-options-reducer';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getMadlibOptionsState = createSelector(
  getPortalState,
  (state: any) => {
    return state.madlibOptions;
  },
);

export const getMadlibOptions = createSelector(
  getMadlibOptionsState,
  (state: IMadlibOptionsState) => {
    return state.madlibOptionsEntity;
  },
);

export const getMadlibOptionsLoadingStatus = createSelector(
  getMadlibOptionsState,
  (state: IMadlibOptionsState) => {
    return state.loading;
  },
);

export const getMadlibOptionsLoadedStatus = createSelector(
  getMadlibOptionsState,
  (state: IMadlibOptionsState) => {
    return state.loaded;
  },
);
